import React, { useEffect, useState } from 'react';
import { promoBarPropTypes } from './PromoBarPropTypes';
import Container from '@Theme/natucare/components/Container/Container';
import CountdownTimer from './components/CountdownTimer/CountdownTimer';
import { isValidDate } from './utils/isValidDate';
import { calculatePromoDates } from './utils/calculatePromoDates';
import { isPromoActive } from './utils/isPromoActive';
import { isDateInFuture } from './utils/isDateInFuture';
import * as styles from './PromoBar.module.scss';
const PromoBar = ({
  text,
  startDate,
  endDate,
  counter,
  link,
  variant,
  backgroundColor,
  textColor,
  isPromoVisibleProp
}) => {
  if (!text && !startDate && !endDate && !counter && !link && !variant) {
    return null;
  }
  const {
    0: isPromoVisible,
    1: setIsPromoVisible
  } = useState(isPromoVisibleProp);
  useEffect(() => {
    if (isValidDate(startDate) && isValidDate(endDate)) {
      const {
        start,
        end
      } = calculatePromoDates({
        startDate,
        endDate
      });
      setIsPromoVisible(isPromoActive(start, end));
    }
  }, [startDate, endDate]);
  if (!isPromoVisible) {
    return null;
  }
  const actionVisible = Boolean((counter === null || counter === void 0 ? void 0 : counter.visible) || (link === null || link === void 0 ? void 0 : link.label) && (link === null || link === void 0 ? void 0 : link.href));
  const counterStartDate = counter === null || counter === void 0 ? void 0 : counter.startDate;
  const counterEndDate = (counter === null || counter === void 0 ? void 0 : counter.endDate) || endDate;
  const timerEndDate = counterEndDate;
  const counterText = counter === null || counter === void 0 ? void 0 : counter.text;
  let isCounterActive = true;
  if (counter !== null && counter !== void 0 && counter.visible) {
    if (isValidDate(counterStartDate) && isValidDate(counterEndDate)) {
      const {
        start,
        end
      } = calculatePromoDates({
        startDate: counterStartDate,
        endDate: counterEndDate
      });
      isCounterActive = isPromoActive(start, end);
    } else if (isValidDate(counterEndDate)) {
      isCounterActive = isDateInFuture(counterEndDate);
    }
  }
  const shouldRenderCounter = Boolean((counter === null || counter === void 0 ? void 0 : counter.visible) && timerEndDate && isCounterActive);
  const rootStyle = {
    '--promo-bar-bg': backgroundColor || undefined,
    '--promo-bar-text': textColor || undefined
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${variant ? styles[`root${variant}`] : ''}`,
    style: rootStyle
  }, /*#__PURE__*/React.createElement(Container, {
    classname: styles.rootContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootRow
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.rootTextWrapper
  }, text && /*#__PURE__*/React.createElement("span", {
    className: styles.rootText,
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), (link === null || link === void 0 ? void 0 : link.label) && (link === null || link === void 0 ? void 0 : link.href) && /*#__PURE__*/React.createElement("a", {
    href: link.href,
    className: styles.rootActionLink,
    dangerouslySetInnerHTML: {
      __html: link.label
    }
  })), shouldRenderCounter && /*#__PURE__*/React.createElement("span", {
    className: styles.rootCounterWrapper
  }, counterText && /*#__PURE__*/React.createElement("span", {
    className: styles.rootCounterLabel
  }, counterText), /*#__PURE__*/React.createElement(CountdownTimer, {
    endDate: timerEndDate
  })))));
};
export default PromoBar;